// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/hospital/departmentInfo/index.less
// module id = 2266
// module chunks = 0